import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import Element from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
import '@/../static/theme/index.css'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import i18n from './lang' // Internationalization
import './icons' // icon
import './errorLog'// error log
import './permission' // permission control
import { hasOperationPerm } from './utils/auth' // operation perm control
import * as filters from './filters' // global filters
import VueResource from 'vue-resource'
// 写入全局方法
Vue.prototype.hasOperPerm = hasOperationPerm
// 定义全局变量 上传地址前缀以及平台
import { PLATFORM, COMPANYNAME } from '@/config/env'
Vue.prototype.$COMPANYNAME = COMPANYNAME
Vue.prototype.$PLATFORM = PLATFORM
// import {
//   iconfontUrl,
//   iconfontVersion
// } from '@/config/env'
// import {
//   loadStyle
// } from '@/utils/assist'

// iconfontVersion.forEach(ele => {
//   loadStyle(iconfontUrl.replace('$key', ele))
// })
Vue.use(VueResource)
Vue.use(Element, {
  size: 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})
// 去掉阿里体验优化
import G2 from '@antv/g2'
G2.track(false)

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App },
  data: {
    eventHub: new Vue()
  }
})



// WEBPACK FOOTER //
// ./src/main.js